export default [
    {
      path: '/calendrier',
      name: 'calendrier',
      component: () => import('@/views/calendries/Calendar.vue'),
    }
]
